<template>
  <div class="process-container" style="padding-bottom: 100px">
    <div v-if="isLoading" style="height: 200px">
      <loading :active.sync="isLoading" 
        :can-cancel="false"
        loader="dots"
        color= "rgb(20, 80, 144)"
        :width="80"
        :is-full-page="false">
      </loading>
    </div>
    <div v-else>
      <div v-if="!isDocumentInWorkflow">   
        <h5>{{ $t('pages.workflow.init') }}</h5><hr>
        <div class="mb-4" v-show="uninitiate">
          <span class="alert alert-danger">
            {{ $t('filemanager.modal.process.warning' ) }}
          </span><br>
        </div>
        <div class="form-group">
          <label>{{ $t('pages.workflow.select') }}:</label>
          <select class="form-control" v-model="selectedProcess">
            <option value=""></option>
            <option :value="process.id" v-for="process in processes" :key="process.id">
              {{ process.name }}
            </option>
          </select>
          <button class="btn btn-primary mt-2"
                  @click="changeState" :disabled="!canInitiate">
            {{ $t('pages.workflow.init') }}
          </button>
        </div>
      </div>
      <div v-else>
        <ul class="verti-timeline list-unstyled">
          <li class="event-list"
              v-for="(state, index) in states" :key="index"
              v-bind:class="{ 'active': state.date_out === null }">
            <div class="event-timeline-dot">
              <i 
                class="bx bx-right-arrow-circle"
                v-bind:class="{ 'bx-fade-right': state.date_out === null }"  
              >
              </i>
            </div>
            <div class="media">
              <div class="mr-2">
                <i 
                  class="bx h2"
                  v-bind:class="{ 
                    'text-success bxs-lock-alt': state.state_type === 'End',
                    'bxs-time-five text-warning': state.state_type === 'Waiting',
                    'text-success bxs-check-circle': state.state_type === 'Approved' || state.state_type === 'Start',
                    'text-danger bxs-x-circle': state.state_type === 'Rejected' || state.state_type === 'Cancelled',
                  }"
                >                      
                </i>
              </div>
              <div class="media-body">
                <div>                  
                  <h5 v-bind:class="{ 
                    'text-success mt-1': state.state_type === 'End' ||
                    state.state_type === 'Approved' || state.state_type === 'Start',
                    'text-danger mt-1': state.state_type === 'Rejected',
                    'text-warning mt-1': state.state_type === 'Waiting',
                  }"
                  >                   
                    {{ getStateName(state.state_type, state.name, state.process) }}
                  </h5>
                
                    <img v-if="state.picture_small !== null"
                         class="rounded-circle header-profile-user"
                         src="@/assets/images/users/default.svg" alt="" />
                    <img v-else class="rounded-circle header-profile-user"
                                src="@/assets/images/users/default.svg" alt="" />
                      <span style="font-size: medium; font-weight: 500;">
                        {{ state.firstname + ' ' + state.lastname }}
                      </span><br>
                      {{ $d(new Date(state.date_in), "short") }}
                      <span v-if="state.date_out">
                        - {{ $d(new Date(state.date_out), "short") }}
                      </span>
                    <table class="table table-sm table-hover">
                      <tr class="pl-2">
                        
                      </tr>
                    </table>
                
                  <p
                    class="card card-body bg-light p-2 mb-2"
                    v-if="state.comment != ' ' && state.name !== 'Start'"
                  >
                    {{ state.comment}}
                  </p>
                  <div v-if="state.can_approve">
                    <textarea rows="2" v-model="comment" class="form-control mt-1"
                              :placeholder="$t('pages.workflow.process.comment')"></textarea><br>
                    <select class="form-control" v-model="selectedAction">
                      {{ $t('pages.workflow.process.select') }}
                      <option :value="action.id" v-for="action in actions" :key="action.id">
                        {{ action.name }}
                      </option>
                    </select>
                    <br>
                    <div v-if="state.next_user_id==null && state.next_state_name!='End'">
                    <label for="">Transferer à</label>
                    <select class="form-control" v-model="nextStateUser">
                      <option value="" selected disabled>Selectionner le prochain acteur</option>
                      <option :value="nextuser.id" v-for="nextuser in nextusers" :key="nextuser.id">
                        {{ nextuser.name }}
                      </option>
                    </select> <br>
                    </div>
                    <button 
                      class="btn btn-primary"
                      :disabled="state.next_user_id == null && state.next_state_name != 'End' ? (selectedAction === '' || nextStateUser == null) : selectedAction === ''"
                      @click="changeState(state)">
                      {{ $t('pages.workflow.process.submit') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </li>                         
        </ul>
      </div>      
    </div>
  </div>
</template>

<script>
import modal from '../mixins/modal';
import Loading from 'vue-loading-overlay';
import workflowApi from '../../../api/workflowApi';
import processApi from '../../../api/processesApi';
import userApi from '../../../api/userApi';

export default {
  name: 'Workflow',
  mixins: [modal],
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      actions: [],
      comment: '',
      image: null,
      isDocumentInWorkflow: false,
      processes: [],
      states: [],
      selectedProcess: null,
      selectedAction: '',
      nextStateUser: null,
      uninitiate: false,
      nextusers: []
    };
  },
  computed: {
    document() {
      return this.$store.getters['selectedItems'][0];
    },
    canSubmit() {
      return this.selectedAction !== '';
    },
    canInitiate() {
      return this.selectedProcess !== '';
    },
  },
  watch: {
    selectedProcess: function() {
      this.uninitiate = false;
    }
  },
  methods: {
    changeState(state) {
      const payload = {
        documentId: this.document.doc_id,
        actionId: this.selectedAction,
        comment: this.comment,
        process: this.selectedProcess,
      }
      if(state.next_user_id == null){
        payload.next_user_id = this.nextStateUser;
        payload.next_state_id = state.next_state_id;
      }
      
      this.isLoading = true;
      workflowApi.changeDocumentState(payload).then(() => {
        workflowApi.getDocumentStates(this.document.doc_id).then((statesResponse) => {
          this.states = statesResponse.data.states;
          this.metadata = statesResponse.data.metadata;
          this.comment = '';
          workflowApi.getDocumentStateActions(this.document.doc_id)
            .then((actionsResponse) => {            
              this.actions = actionsResponse.data;
              this.isDocumentInWorkflow = true;
              this.isLoading = false;
              this.$emit('changed');
            });
          });
      }).catch((error) => {
        this.isLoading = false;
        if (error.response.status == 400) {
          if (error.response.data.context === 'unindexed') {
            const params = { duration: 3000, position: 'top-right' };
            this.$toasted.error(this.$t('pages.workflow.unindexed'), params);
          }
        }
      });
    },
    getStateName(stateType, stateName, processName) {
      if (stateName == 'Start') {
        return `${this.$t('pages.workflow.state.start')} : ${processName}`;
      }
      switch (stateType) {
        case 'Start':
          return `${this.$t('pages.workflow.state.start')} : ${processName}`
        case 'End':
          return this.$t('pages.workflow.state.end')
        case 'Waiting':
          return `${this.$t('pages.workflow.state.waiting')} ${stateName}`
        case 'Approved':
          return this.$t('pages.workflow.details.approved')
        case 'Rejected':
          return this.$t('pages.workflow.state.rejected')
        case 'Cancelled':
          return this.$t('pages.workflow.state.cancelled')
      }
    },
  },
  mounted() {
    this.isLoading = true;
    userApi.all().then((response) => {
      const users = response.data;
      this.nextusers = users.map((user) => {
        return {
          id: user.id,
          name: user.firstname+' '+user.lastname,
          url: user.picture_medium,
        };
      });
    });
    workflowApi.checkDocument(this.document.doc_id).then((res) => {
      if (!res.data.check) {
        this.isDocumentInWorkflow = res.data.check;
        processApi.all().then((response) => {
          this.processes = response.data.processes.filter((e) => e.is_active == 1);
          this.isLoading = false;
        });
      } else {
        workflowApi.getDocumentStates(this.document.doc_id).then((statesResponse) => {
          this.isDocumentInWorkflow = true;
          this.states = statesResponse.data.states;
          this.metadata = statesResponse.data.metadata;
          this.selectedProcess = statesResponse.data.states.length != 0 ? statesResponse.data.states[0].process_id : null;
          workflowApi.getDocumentStateActions(this.document.doc_id)
          .then((actionsResponse) => {            
            this.actions = actionsResponse.data;
            this.isLoading = false;
          });
        });
      }
    });
  } 
};
</script>

<style lang="scss">

</style>
